import angular from 'angular';

const projectService = angular.module('ttb.services.configuration.filterStorage.service', [])
    .factory('filterStorageService', [
        () => {
            return {
                projectInGroup: {},
                teamInGroup: {},
                userInGroup: {},
                company: {},
            };
        }])
    .name;

export default projectService;



// WEBPACK FOOTER //
// ../services/configuration/filter-storage.service.js